import { Snack, Div, Span, Button } from "@tblabs/truffle";
import { BasketItem } from "../../../Services/Basket/BasketItem";
import { BasketIcon } from "../../Components/NavBar/BasketIcon";
import { CloseIcon } from "../../../Components/CloseIcon";


export class BasketNotification extends Snack
{
    constructor(item: BasketItem, title: string)
    {
        super(
            new Div("cart-notification").Style("will-change: transform, opacity; opacity: 1; transform: none;").Append(
                new Div("cart-notification__header").Append(
                    new Div("cart-notification__header-content").Append(
                        new BasketIcon(),
                        new Span(title).Class("cart-notification__header-title")
                    ),
                    new Button("").Class("cart-notification__close")
                        .Append(new CloseIcon())
                        .OnClick(() => this.Close())
                ),
                new Div("cart-notification__body").Append(
                    new Div("cart-notification__item-name").Text(item.Product?.BasketName.value || ""),
                    new Div("cart-notification__item-details").Append(
                        new Div().Text(item.Label.value),
                        new Div("cart-notification__item-price").Text(`Cena: ${item.FinalPriceAfterDiscount.value} zł`)
                    )
                )
            ),
            "",
            { clickAnywhereToClose: true, autoCloseTimeout: 3500 }
        );
    }
}

